import { options as stateData } from 'ui-blocks/form-elements/select/StateSelect';
import axios from 'axios';

const GEO_DATA_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_GEO_DATA_PUBLIC }`;

export const getGeoLocationSASuggestions = (payload) => {
   return axios.get(
      `${ GEO_DATA_SECURE_BASE_URL }location/get-suggestions?keyword=${ payload.keyword }`,
   );
};

export const getStateSuggestions = (keyword) => {
   return new Promise((resolve) => {
      return resolve({
         data: stateData.filter((state) => {
            return state.label.toLowerCase().includes(keyword?.toLowerCase());
         }),
      });
   });
};
